import { render, staticRenderFns } from "./homeOrganization.vue?vue&type=template&id=2b13839a&scoped=true&"
import script from "./homeOrganization.vue?vue&type=script&lang=js&"
export * from "./homeOrganization.vue?vue&type=script&lang=js&"
import style0 from "./homeOrganization.vue?vue&type=style&index=0&id=2b13839a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13839a",
  null
  
)

export default component.exports